export default __webpack_public_path__ + "static/media/warning--dead-end-go-right--g1.b71f819e.png";